import { render } from "./CreateStudyCardView.vue?vue&type=template&id=62d0a434&scoped=true"
import script from "./CreateStudyCardView.vue?vue&type=script&lang=js"
export * from "./CreateStudyCardView.vue?vue&type=script&lang=js"

import "./CreateStudyCardView.vue?vue&type=style&index=0&id=62d0a434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d0a434"]])

export default __exports__